// @ts-nocheck
import action from 'utils/actionCreators';

export const USER_LOGIN_REQUEST = 'VARICON/@src/app/Login/USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'VARICON/@src/app/Login/USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'VARICON/@src/app/Login/USER_LOGIN_FAILURE';

export const userLoginRequest = action(USER_LOGIN_REQUEST, 'payload');
export const userLoginSuccess = action(USER_LOGIN_SUCCESS, 'payload');
export const userLoginFailure = action(USER_LOGIN_FAILURE);

export const LOGOUT_USER_REQUEST = 'VARICON/@src/app/LOGOUT_USER_REQUEST';
export const LOGOUT_USER_SUCCESS = 'VARICON/@src/app/LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILURE = 'VARICON/@src/app/LOGOUT_USER_FAILURE';

export const logoutUsersRequest = action(LOGOUT_USER_REQUEST, 'payload');
export const logoutUsersSuccess = action(LOGOUT_USER_SUCCESS);
export const logoutUsersFailure = action(LOGOUT_USER_FAILURE);
